module.exports = __webpack_public_path__ + "img/Artboard-5.293412c2.png";